import { IOrganizationUser } from "@home-health-notify/domain";
import PowerIcon from "@mui/icons-material/Power";
import PowerOffIcon from "@mui/icons-material/PowerOff";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, Tooltip } from "@mui/material";
import { getSocketStatusConfig } from "hhn-commons";

interface SocketStatusDotProps {
  isConnected: boolean;
  isConnecting: boolean;
  orgUser: IOrganizationUser;
  size?: number;
}

export const SocketStatusDot = ({
  isConnected,
  isConnecting,
  orgUser,
  size = 14,
}: SocketStatusDotProps) => {
  const config = getSocketStatusConfig(isConnected, isConnecting);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const socketManager = orgUser.getSocketManager();
    if (isConnected) {
      await socketManager.disconnect();
    } else if (!isConnecting) {
      await socketManager.connect();
    }
  };

  const tooltipText = isConnected
    ? "Connected - Click to disconnect"
    : isConnecting
      ? "Connecting..."
      : "Disconnected - Click to connect";

  const iconProps = {
    sx: {
      fontSize: size,
      color: config.color,
    },
  };

  return (
    <Tooltip title={tooltipText} placement="right">
      <Box
        onClick={handleClick}
        sx={{
          position: "absolute",
          bottom: -2,
          left: -2,
          backgroundColor: "white",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "1px",
          cursor: isConnecting ? "wait" : "pointer",
          "&:hover": {
            transform: "scale(1.1)",
          },
        }}
      >
        {isConnected ? (
          <PowerIcon {...iconProps} />
        ) : isConnecting ? (
          <SyncIcon
            {...iconProps}
            sx={{
              ...iconProps.sx,
              animation: "spin 1s linear infinite",
              "@keyframes spin": {
                "0%": { transform: "rotate(0deg)" },
                "100%": { transform: "rotate(360deg)" },
              },
            }}
          />
        ) : (
          <PowerOffIcon {...iconProps} />
        )}
      </Box>
    </Tooltip>
  );
};
